import * as React from 'react';

function SvgIconVr(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={14} {...props}>
      <path
        fill="#38B2A6"
        d="M13.544 11.564l-3.078 2.505c0-.441-.038-.72.007-.989.103-.614-.205-.77-.815-.803-2.379-.136-4.711-.533-6.858-1.54A8.2 8.2 0 01.682 9.312c-.914-.863-.888-1.954-.051-2.895.781-.875 1.83-1.37 2.966-1.726-.601.339-1.244.626-1.797 1.024-1.215.872-1.22 1.954-.015 2.833 1.55 1.13 3.422 1.516 5.304 1.822 1.076.176 2.173.247 3.325.37.038-.571.067-1.03.103-1.627l3.027 2.452zm.787.648c-.027-.08-.069-.163-.078-.253-.148-1.197-.055-1.212 1.217-1.433a50.47 50.47 0 004.958-1.109c.698-.196 1.36-.63 1.92-1.082.918-.743.91-1.638.008-2.41-.508-.432-1.135-.748-1.69-1.138 1.148.441 2.222.99 2.895 2.021.487.747.5 1.562-.118 2.223a7.896 7.896 0 01-1.876 1.483c-1.808 1.004-5.64 1.855-7.236 1.698zM3.75 0h2.002l2.194 4.877c.066.148.295.15.365.001L10.58 0h2.014L9.318 6.78c-.47.973-1.983.961-2.437-.016L3.751 0zm13.485 4.51l1.992 2.993H17.26L15.265 4.51h-1.026v2.993h-1.644V2.844h4.279a.58.58 0 00.57-.59.58.58 0 00-.57-.59h-4.279V0h5.353c.63 0 1.14.528 1.142 1.181l.005 2.126c.002.667-.52 1.207-1.162 1.207l-.488-.004h-.209z"
      />
    </svg>
  );
}

export default SvgIconVr;
